import { render, staticRenderFns } from "./UserSetupTermsAndConditions.vue?vue&type=template&id=5a1a799c&scoped=true&"
import script from "./UserSetupTermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./UserSetupTermsAndConditions.vue?vue&type=script&lang=js&"
import style0 from "./UserSetupTermsAndConditions.vue?vue&type=style&index=0&id=5a1a799c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1a799c",
  null
  
)

export default component.exports